// LeadGen action types

const leadGenActionTypes = {
  IS_LEADGEN_PROCESSING_TYPE: 'IS_LEADGEN_PROCESSING_TYPE',
  SET_LEADGEN_IS_ALREADY_SHOWN: 'SET_LEADGEN_IS_ALREADY_SHOWN',
  RESET_LEADGEN_STATUS: 'RESET_LEADGEN_STATUS'
};

export default leadGenActionTypes;
